import { Button, Flex, Input, Modal, Select } from "src/elements";
import { useEffect, useState } from "react";
import { useApi } from "src/api";
import { useModals } from "src/components/Modals";
import { useLoaders } from "src/components/InlineLoader";
import { RoutePutUsers_userId_ } from "@CommonApi/users/_userId_";
import { useUsersPage } from "src/pages/Users/store/hooks";
import { RoleCode } from "@CommonUtils/RolesPermissions";
import { useAtom } from "jotai";
import { editUserDataAtom } from "./store/atoms";
import { ROLE_OPTIONS } from "src/pages/Users/store/constants";

export const EditUserModal = () => {
  const { closeModal } = useModals();
  const { putUpdateUserApi } = useApi();
  const { hasLoader } = useLoaders();
  const { loadUsers } = useUsersPage();
  const [userData, setUserData] = useAtom(editUserDataAtom);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [roleCode, setRoleCode] = useState<RoleCode>(RoleCode.OPERATOR);
  const [isEditSuccessful, setIsEditSuccessful] = useState(false);
  const isEditLoading = hasLoader(RoutePutUsers_userId_);

  useEffect(() => {
    if (userData) {
      setFirstName(userData.firstName);
      setLastName(userData.lastName);
      setEmail(userData.email);
      setRoleCode(userData.roleCode);
    }

    return () => {
      setUserData(null);
    };
  }, []);

  const editUser = async () => {
    if (!userData) return;

    const response = await putUpdateUserApi(userData.id, {
      firstName,
      lastName,
      email,
      roleCode,
    });

    if (response) {
      setIsEditSuccessful(true);

      setTimeout(() => {
        loadUsers();
        closeModal("EditUserModal");
      }, 1000);
    }
  };

  return (
    <Modal name="EditUserModal" title="Edit User" width="300px">
      <Flex padding="20px" column gap="20px">
        <Input value={firstName} setValue={setFirstName} title="First name" placeholder="John" />

        <Input value={lastName} setValue={setLastName} title="Last name" placeholder="Doe" />

        <Input
          value={email}
          setValue={setEmail}
          title="E-mail"
          placeholder="example@omnistream.co"
        />

        <Select title="Role" options={[...ROLE_OPTIONS]} value={roleCode} setValue={setRoleCode} />

        <Flex justify="center">
          <Button
            isDisabled={!firstName || !lastName || !email}
            isLoading={isEditLoading}
            isSuccessful={isEditSuccessful}
            onClick={editUser}
          >
            Save Changes
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
